module.exports = __webpack_public_path__ + "img/c08_buildingtechmahouttraining_Normal_ua.04036049.webp";